import styled from "styled-components";
import { px2rem } from "../../../utils/css";

export const ConponWrapper = styled("div").withConfig({
	shouldForwardProp: (prop) => !["col"].includes(prop),
})<{ col: number }>`
	padding: ${(props: { col: number }) => {
		if (props.col === 1) {
			return ` 0 ${px2rem(12)} `;
		}
		return `0 ${px2rem(12)}`;
	}};
`;
